module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAIlJREFUSA3tVUEKACEIzH3H7oP6/xPWf7gKBdXJNerSCJKBMwODaBKRrPlqesN6cyphteZvPBlIOe5K5HyZiB7rDeMVKE6xrk2FqQiH8FfHtvED4W1mw2pYvcwBGy4OsLeYtvZSse3a0JKvCrP4ynPAO2tVFI97vG24cCRg9TIHMFzLrB2Jz7vHH0d23DRhr83jAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fb.png
// module id = Y3Bk
// module chunks = 1